import {
  Grid,
  GridItem,
  Nowrap,
  Text,
  useViewport,
  Link,
  Box,
} from '@farmersdog/corgi-x';
import { WsavaLogo } from '../../assets/WsavaLogo';
import { ApopLogo } from '../../assets/ApopLogo';

import config from 'src/config';

import CheckMark from '../../assets/checkmark.svg';
import Certification from '../../assets/certification.svg';
import Checklist from '../../assets/checklist.svg';
import CertificationStethoscope from '../../assets/certification-stethoscope.svg';

import { CtaTrackerV2, HomepageRedesignSections } from '../CtaTrackerV2';

import classNames from 'classnames';
import styles from '../VetsKnowBest/VetsKnowBest.module.css';
import { useTrackedSectionRef } from 'src/hooks/useTrackedSections';

interface Certification {
  icon: JSX.Element;
  text: string | React.ReactNode;
}

const CERTIFICATIONS: Certification[] = [
  {
    icon: <CertificationStethoscope aria-hidden="true" />,
    text: 'On-staff veterinarians and board-certified nutritionists',
  },
  {
    icon: <Checklist aria-hidden="true" />,
    text: (
      <>
        Meets or exceeds WSAVA’s guidelines for selecting{' '}
        <Nowrap>pet foods</Nowrap>
      </>
    ),
  },
  {
    icon: <Certification aria-hidden="true" />,
    text: 'AAFCO-certified complete and balanced nutrition',
  },
  {
    icon: <CheckMark aria-hidden="true" />,
    text: 'Rigorously tested for quality and safety',
  },
];

export const VetVerifiedQuality = () => {
  const viewport = useViewport();
  const isMobile = !viewport?.lg;

  const vetContentRef = useTrackedSectionRef<HTMLDivElement>(
    HomepageRedesignSections.VetVerifiedQuality
  );

  return (
    <Box px={24} className={styles.container} ref={vetContentRef}>
      <Grid
        flexDirection={isMobile ? 'column' : 'row'}
        gap={isMobile ? 'md' : 'xxl'}
        justifyContent="center"
      >
        {CERTIFICATIONS.map(({ icon, text }, index) => (
          <GridItem
            key={`${index}`}
            sm={12}
            lg={3}
            alignItems="center"
            className={classNames(styles.certificationContainer, {
              [styles.withBottomBorder]: index < CERTIFICATIONS.length - 1,
            })}
          >
            <div className={styles.iconContainer}>{icon}</div>
            <Text
              weight="semibold"
              as="p"
              variant="heading-16"
              color="kale-3"
              vSpacing="none"
              align={isMobile ? 'left' : 'center'}
            >
              {text}
            </Text>
          </GridItem>
        ))}
      </Grid>
      <Grid
        className={styles.associationLogos}
        justifyContent="center"
        gap="sm"
      >
        <WsavaLogo />
        <ApopLogo />
      </Grid>
      <div className={styles.vetProfessional}>
        <Text as="div" align="center" color="kale-3">
          Are you a vet professional?
        </Text>
        <Text as="div" align="center" color="kale-3">
          Visit our{' '}
          <CtaTrackerV2
            type="select"
            moduleLevel={1}
            moduleName={HomepageRedesignSections.VetVerifiedQuality}
          >
            <Link
              to={`${config('app.vetPortalUrl')}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.vetPortalLink}
            >
              Vet Team Portal
            </Link>
          </CtaTrackerV2>
        </Text>
      </div>
    </Box>
  );
};
